export default {
      id: "i-car-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "img/sprite.svg#i-car",
      toString: function () {
        return this.url;
      }
    }